import { render, staticRenderFns } from "./CommonHint.vue?vue&type=template&id=67f94c64&scoped=true"
import script from "./CommonHint.vue?vue&type=script&lang=js"
export * from "./CommonHint.vue?vue&type=script&lang=js"
import style0 from "./CommonHint.vue?vue&type=style&index=0&id=67f94c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f94c64",
  null
  
)

export default component.exports